import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ModalService } from './modal.service';

@Injectable({
  providedIn: 'root',
})
export class SessionTimeoutModalService {
	public isOpen = false;

	public sessionTimeoutModalOpenChanged = new Subject<boolean>();

  constructor(private modalService:ModalService) { }

	public setIsOpen(isOpen:boolean) {
		this.isOpen = isOpen;
		this.sessionTimeoutModalOpenChanged.next(isOpen);
	}

	public showModal() {
    this.modalService.showModal('session-timeout-modal');
		this.setIsOpen(true);
  }

  public closeModal() {
    this.modalService.closeModal('session-timeout-modal');
  }
}
